import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18 18L14.1333 14.1333M16.2222 9.11111C16.2222 13.0385 13.0385 16.2222 9.11111 16.2222C5.18375 16.2222 2 13.0385 2 9.11111C2 5.18375 5.18375 2 9.11111 2C13.0385 2 16.2222 5.18375 16.2222 9.11111Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgSearch;
